<script setup lang="ts">
import { onMounted, onUnmounted, ref, computed } from 'vue';
import { SalesRep, MessageCenter } from '@/views/Admin/Tenants/components';
import { can, useTenant } from '@/composables';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';

const currentView = ref('salesreps');
const hasSalesRepsAccess = ref(false);
const $tenant = useTenant();

onMounted(() => {
  updateCurrentView();
  window.addEventListener('hashchange', updateCurrentView);
  if (can([PERMISSIONS.SALESREPS_INDEX])) {
    hasSalesRepsAccess.value = true;
  }
});

function updateCurrentView() {
  currentView.value = window.location.hash.replace('#', '') || 'salesreps';
}

onUnmounted(() => {
  window.removeEventListener('hashchange', updateCurrentView);
});

const isMessageCenterEnabled = computed(() => {
  return $tenant.tenantSettingEnabled(TENANT_SETTINGS.MESSAGE_CENTER);
});
</script>

<template>
  <div class="w-full flex flex-row">
    <div class="col-3 bg-white p-3 border-round-2xl">
      <ul class="list-none p-0">
        <li class="flex items-center border-bottom-2 border-100">
          <a
            class="p-3 font-semibold no-underline"
            :class="currentView === 'salesreps' ? 'text-color-green' : 'text-500'"
            href="#salesreps"
          >
            Sales Reps List
          </a>
        </li>
        <li v-if="isMessageCenterEnabled" class="flex items-center border-bottom-2 border-100">
          <a
            class="p-3 font-semibold no-underline"
            :class="currentView === 'messagecenter' ? 'text-color-green' : 'text-500'"
            href="#messagecenter"
          >
            Message Center
          </a>
        </li>
      </ul>
    </div>

    <div class="col-9 ml-4 pr-4">
      <div v-if="currentView === 'salesreps' && hasSalesRepsAccess">
        <SalesRep />
      </div>

      <div v-else-if="currentView === 'messagecenter'">
        <MessageCenter />
      </div>
    </div>
  </div>
</template>
